import React from "react";
import { formatDateTimeNoSeconds } from "../../utils/dateTime";

/**
 * Shows when a set of answers was last saved.
 *
 * Answers are owned per user, so both the tester working on their own draft and
 * the reviewer reading a submitted declaration need to see the age of the data
 * they are looking at.
 *
 * @param {string|Date|null} value  Timestamp to display. Nothing is rendered when absent.
 * @param {string} [label]          Leading text before the timestamp.
 */
export default function LastUpdated({ value, label = "Senast uppdaterad", style }) {
  const formatted = formatDateTimeNoSeconds(value);
  if (!formatted) return null;

  return (
    <span
      style={{ fontSize: "0.875rem", color: "var(--ids-palette-neutral-30, #555)", ...style }}
    >
      {label}: <time dateTime={new Date(value).toISOString()}>{formatted}</time>
    </span>
  );
}
